const CompletedOnTimeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" fill="#ECFDF5" />
      <path
        d="M13.911 18.7287L10.5943 15.412L9.6665 16.3333L13.911 20.5778L22.5677 11.9213L21.6464 11L13.911 18.7287Z"
        fill="#111113"
      />
    </svg>
  )
}

export default CompletedOnTimeIcon
